import {Map} from 'immutable'
import {useState} from 'react'
import PropTypes from 'prop-types'
import {useMutation} from '@apollo/client'

import ConfirmationModal from '../../../../../shared_components/mui_base_components/modals/confirmation_modal/ConfirmationModal'

import {DELETE_ITEM_RESPONSE_GROUP} from '../../../../../graphql/mutations/itemResponse'
import {DEPUTIES} from '../../../../../graphql/queries/deputy'
import {suggestedDeputiesRefetchQueries} from '../../../../../lib/deputyPermissionTools'
import {useNotificationContext} from '../../../../../shared_components/notifications/NotificationContext'
import Logger from '../../../../../lib/NewLogger'

import './deleteCompoundResponseGroup.scss'

const DeleteCompoundResponseGroup = props => {
  const everplanId = props.itemResponse.get('everplan-id')

  const [processing, setProcessing] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const {alwaysNotify} = useNotificationContext()

  const [deleteItemResponseGroup] = useMutation(DELETE_ITEM_RESPONSE_GROUP, {
    refetchQueries: [
      {query: DEPUTIES, variables: {everplanId}},
      ...suggestedDeputiesRefetchQueries({itemResponse: props.itemResponse, ownEverplan: props.ownEverplan})
    ],
    onQueryUpdated(observableQuery) {
      if (
        observableQuery.queryName === 'suggestedDeputies' ||
        (props.ownEverplan && observableQuery.queryName === 'deputies')
      )
        observableQuery.refetch()
    }
  })

  const logEvent = name => {
    const itemName = props.itemResponse.get('name')
    Logger.log({
      name,
      payload: {
        actor: props.actor,
        context: props.context,
        everplan_id: everplanId,
        item: itemName,
        type: 'vault',
        wildcard: itemName
      }
    })
  }

  const toggleModal = () => {
    showModal ? logEvent('returned_to_response_group') : logEvent('viewed_delete_confirmation_modal')

    setShowModal(prevShowModal => !prevShowModal)
  }

  const deleteResponseGroup = () => {
    setProcessing(true)

    deleteItemResponseGroup({
      variables: {
        input: {
          itemId: props.itemResponse.get('item-id'),
          firstGroupId: props.responseGroup.get('id')
        },
        everplanId
      }, onCompleted: () => {
        alwaysNotify.shortSuccess(props.ownEverplan ?
          'Your information has been deleted.' :
          "Your client's information has been deleted."
        )

        props.exit()
      }
    })
  }

  const onDeleteItem = () => {
    logEvent('clicked_delete_all')
    toggleModal()
  }

  return (
    <div className='delete-compound-response-group'>
      <ConfirmationModal
        bodyText='All information associated with it will be deleted.'
        confirmButtonText='Delete'
        headingText='Delete this item?'
        loading={processing}
        onClose={toggleModal}
        onConfirmation={deleteResponseGroup}
        open={showModal}
      />
      <button type='button' onClick={onDeleteItem} className='delete-responses-trigger flex-child'>
        Delete item
      </button>
    </div>
  )
}

DeleteCompoundResponseGroup.propTypes = {
  actor: PropTypes.string,
  context: PropTypes.string,
  exit: PropTypes.func.isRequired,
  itemResponse: PropTypes.instanceOf(Map),
  ownEverplan: PropTypes.bool,
  responseGroup: PropTypes.instanceOf(Map)
}

export default DeleteCompoundResponseGroup
